import React from 'react';
import MyRecord from './MyRecord';
import { useTitle } from '../../hooks/useTitle';

const MypageRecord = () => {
  useTitle('Ton Bébé | 提供実績');

  return (
    <main className="sub">
      <MyRecord />
    </main>
  );
}

export default MypageRecord;
